var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#E4E4E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6225_20257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.769 124.349C130.952 124.852 130.988 125.397 130.872 125.919C130.756 126.442 130.493 126.92 130.115 127.299L121.678 135.736C121.417 135.998 121.106 136.206 120.765 136.348C120.424 136.489 120.057 136.562 119.688 136.563C119.595 136.568 119.503 136.568 119.41 136.563C118.996 136.522 118.596 136.39 118.239 136.176C117.882 135.962 117.577 135.671 117.346 135.325L101.853 112.08L94.3753 119.543V128.125C94.3749 128.87 94.0791 129.584 93.5526 130.111C93.5526 130.111 88.6308 135.054 87.9698 135.694C87.6951 135.982 87.3618 136.207 86.9925 136.355C86.3042 136.636 85.5329 136.632 84.8471 136.346C84.1613 136.059 83.6169 135.513 83.3327 134.826L83.3116 134.773L78.1436 121.85L65.1956 116.671C64.7637 116.498 64.3813 116.221 64.0829 115.864C63.7844 115.507 63.5791 115.082 63.4854 114.626C63.3917 114.171 63.4125 113.699 63.5459 113.253C63.6793 112.808 63.9212 112.402 64.2499 112.073L69.8749 106.448C70.1375 106.185 70.4495 105.978 70.7928 105.836C71.1362 105.695 71.5041 105.623 71.8753 105.625H80.4534L87.9311 98.1474L64.6893 82.6505C64.3427 82.4197 64.0516 82.1149 63.8371 81.7579C63.6226 81.401 63.4901 81.0009 63.4491 80.5865C63.408 80.1721 63.4595 79.7537 63.5998 79.3616C63.7402 78.9695 63.9658 78.6135 64.2604 78.3193L72.6979 69.8818C73.0764 69.5034 73.555 69.2409 74.0775 69.1251C74.6 69.0093 75.1446 69.0449 75.6476 69.2278L105.861 80.2142L116.946 69.1294C118.792 67.2833 121.296 66.2461 123.907 66.2461C125.199 66.2461 126.479 66.5007 127.674 66.9954C128.868 67.4902 129.953 68.2153 130.867 69.1294C131.782 70.0435 132.507 71.1288 133.001 72.3231C133.496 73.5175 133.751 74.7976 133.751 76.0903C133.751 77.3831 133.496 78.6632 133.001 79.8576C132.507 81.0519 131.782 82.1372 130.867 83.0513L119.783 94.1361L130.769 124.349Z",
    fill: "#272727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6225_20257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white",
    transform: "translate(55 55)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.6add21ad7fffa51adc7b41a12c22040c.svg";
export { ForwardRef as ReactComponent };